import { createSlice } from '@reduxjs/toolkit';
import {
  createComplaintType,
  deleteComplaintType,
  fetchComplaintTypeById,
  fetchComplaintTypes,
  updateComplaintType,
} from './actions';

const initialState = {
  complaintList: [],
  selected: null,
  loading: false,
  saving: false,
  error: null,
};

const COLLECTION_KEYS = [
  'data',
  'items',
  'results',
  'content',
  'records',
  'list',
  'payload',
  'response',
  'result',
];

const extractItems = (value) => {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== 'object') return [];

  for (const key of COLLECTION_KEYS) {
    if (value[key] !== undefined) {
      const items = extractItems(value[key]);
      if (items.length || Array.isArray(value[key])) return items;
    }
  }

  return [];
};

const complaintTypeSlice = createSlice({
  name: 'complaintType',
  initialState,
  reducers: {
    setComplaintTypeActive(state, action) {
      const { id, isActive } = action.payload ?? {};
      if (id == null) return;
      state.complaintList = state.complaintList.map((item) => (
        String(item?.id) === String(id) ? { ...item, isActive } : item
      ));
      if (String(state.selected?.id) === String(id)) {
        state.selected = { ...state.selected, isActive };
      }
    },
    // Unused: nothing dispatches these helpers.
    // clearComplaintTypeError(state) {
    //   state.error = null;
    // },
    // clearSelectedComplaintType(state) {
    //   state.selected = null;
    // },
    // resetComplaintTypeState() {
    //   return initialState;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComplaintTypes.pending, (state) => {
        console.log('fetchComplaintTypes.pending');
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplaintTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.complaintList = extractItems(action.payload);
        console.log(state.complaintList, 'state.complaintList');
      })
      .addCase(fetchComplaintTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch complaint types';
      })

      .addCase(fetchComplaintTypeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplaintTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selected = action.payload?.data ?? action.payload;
      })
      .addCase(fetchComplaintTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch complaint type';
      })

      .addCase(createComplaintType.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(createComplaintType.fulfilled, (state, action) => {
        state.saving = false;
        const createdItem = action.payload?.data ?? action.payload;
        state.complaintList = [
          createdItem,
          ...state.complaintList.filter((item) => item?.id !== createdItem?.id),
        ];
        state.selected = createdItem;
      })
      .addCase(createComplaintType.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to create complaint type';
      })

      .addCase(updateComplaintType.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateComplaintType.fulfilled, (state, action) => {
        state.saving = false;
        const updatedItem = action.payload?.data ?? action.payload;
        state.complaintList = state.complaintList.map((item) =>
          item?.id === updatedItem?.id ? updatedItem : item,
        );
        state.selected = updatedItem;
      })
      .addCase(updateComplaintType.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to update complaint type';
      })

      .addCase(deleteComplaintType.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(deleteComplaintType.fulfilled, (state, action) => {
        state.saving = false;
        const id = action.payload?.id ?? action.meta?.arg;
        state.complaintList = state.complaintList.filter(
          (item) => String(item?.id) !== String(id),
        );
        if (String(state.selected?.id) === String(id)) {
          state.selected = null;
        }
      })
      .addCase(deleteComplaintType.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to delete complaint type';
      });
  },
});

export const { setComplaintTypeActive } = complaintTypeSlice.actions;

// export const { clearComplaintTypeError, clearSelectedComplaintType, resetComplaintTypeState } =
//   complaintTypeSlice.actions;

export default complaintTypeSlice.reducer;
